import DuckEntity from './DuckEntity';
import {apiAction, apiFetch, getMetaContent} from "../utils";

const duck = new DuckEntity('exportConfigs');

const update = ({exportConfig, paramFile}) => {
  let token = getMetaContent('csrf-token');
  const headers = { Accept: 'application/json', 'X-CSRF-Token': token };
  const data = new FormData();
  data.append('export_config', JSON.stringify(exportConfig));
  if (paramFile){
    data.append('params_file', paramFile);
  }

  const actionParams = {export_configs: exportConfig, params_file: paramFile}
    return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.put(state, duck.config.entityApiPath(exportConfig.id), null, { rawBody: data, headers }),
    actionParams
  );
};


export const exportConfigs = {
  ...duck,
  actions: {
    ...duck.actions,
    update
  }
};

export default exportConfigs.reducer;